import { createTheme } from '@material-ui/core/styles';
import { ToggleButtonClassKey } from '@material-ui/lab/ToggleButton';
import type { } from '@material-ui/lab/themeAugmentation';
import { Popper } from '@material-ui/core';

const primary = '#e42d24';
const secondary = '#060';
const sec = '#007bff';
const spacing = 8;

const theme = createTheme({
    spacing: spacing,
    palette: {
        primary: {
            main: primary
        },
        secondary: {
            main: secondary,
        }
    },
    typography: {
        fontFamily: '"Open Sans", sans-serif',
        h1: {
            fontSize: 48,
            paddingBottom: spacing
        },
        h2: {
            fontSize: 40,
            paddingBottom: spacing
        },
        h3: {
            fontWeight: 400,
            fontSize: 32,
            paddingBottom: spacing
        },
        h4: {
            fontWeight: 400,
            fontSize: 24,
            paddingBottom: spacing
        },
        h5: {
            fontWeight: 400,
            fontSize: 16
        },
        h6: {
            fontWeight: 400,
            fontSize: 8,
            paddingBottom: spacing
        },
        subtitle1: {
            fontSize: 12,
        },
        subtitle2: {
            fontSize: 12,
        }
    },
    props: {
        MuiFormControl: {
            size: 'small'
        },
        MuiAutocomplete: {
            PopperComponent(props) { return (<Popper {...props} placement="bottom-start" />) }
        }
    },
    overrides: {
        MuiGrid: {
            item: {
                padding: spacing
            }
        },
        MuiButton: {
            root: {
                color: 'inherit',
                marginRight: spacing * 2,
                '&:last-child': {
                    marginRight: 0
                }
            }
        },
        MuiFormControl: {
            root: {
                minWidth: '120px',
            }
        },
        MuiTableCell: {
            root: {
                padding: spacing * 1.5
            },
            head: {
                fontWeight: 600
            }
        },
        MuiDialogTitle: {
            root: {
                paddingTop: spacing * 2,
                paddingBottom: spacing * 2,
                paddingLeft: spacing * 3,
                paddingRight: spacing * 3,
            }
        },
        MuiDialogContent: {
            root: {
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: spacing * 2,
                paddingRight: spacing * 2,
                '&:first-child': {
                    paddingTop: 0
                }
            }
        },
        MuiDialogContentText: {
            root: {
                marginBottom: 0,
                paddingLeft: spacing,
                paddingRight: spacing
            }
        },
        MuiCardHeader: {
            title: {
                fontWeight: 500,
                paddingBottom: 0,
                fontSize: 16
            }
        },
        MuiCardActions: {
            root: {
                padding: 16
            }
        },
        MuiLink: {
            root: {
                color: secondary
            }
        },
        MuiAutocomplete: {
            popper: {
                minWidth: '25%'
            }
        }
    }
})

declare module '@material-ui/core/styles/overrides' {
    export interface ComponentNameToClassKey {
        MuiToggleButton: ToggleButtonClassKey;
    }
}


export default theme